/** @format */

export const SET_ADVANCED_QUESTIONS = "SET_ADVANCED_QUESTIONS";
export const SET_INTERMEDIATE_QUESTIONS = "SET_INTERMEDIATE_QUESTIONS";
export const SET_BASIC_QUESTIONS = "SET_BASIC_QUESTIONS";

export const setAdvancedQuestion = (data) => ({
  type: SET_ADVANCED_QUESTIONS,
  payload: data,
});

export const setIntermediateQuestion = (data) => ({
  type: SET_INTERMEDIATE_QUESTIONS,
  payload: data,
});
export const setBasicQuestion = (data) => ({
  type: SET_BASIC_QUESTIONS,
  payload: data,
});
